import z from "zod";

import { LOADER_SIZES, LOADER_VARIANTS } from "./constants";

const booleanAttribute = z
  .string()
  .optional()
  .transform((value) => value !== undefined && value !== "false");

export const loaderDataSchema = z.object({
  variant: z.enum(LOADER_VARIANTS).optional(),
  size: z.enum(LOADER_SIZES).optional(),
  currentColor: booleanAttribute,
  label: z.string().optional(),
});

export type LoaderDataProps = z.infer<typeof loaderDataSchema>;
